// import React, { useState, useEffect } from 'react';
// import './LeaderboardTable.css';
// import axios from 'axios';

// // Axios instance
// const api = axios.create({
//   baseURL: process.env.REACT_APP_BASE_URL,
//   headers: { 'Content-Type': 'application/json' },
// });

// const LeaderboardTable = () => {
// //   const teams = [
// //     { rank: 1, name: 'MATHURA YODHAS (Q)', total: 5, win: 4, loss: 1, points: 12, setRatio: 2.00, pointsRatio: 1.08 },
// //     { rank: 2, name: 'MUZAFFARNAGAR LIONS', total: 4, win: 3, loss: 1, points: 9, setRatio: 2.00, pointsRatio: 1.20 },
// //     { rank: 3, name: 'NOIDA THUNDERS', total: 4, win: 2, loss: 2, points: 8, setRatio: 1.40, pointsRatio: 1.17 },
// //     { rank: 4, name: 'GORAKHPUR GIANTS', total: 4, win: 2, loss: 2, points: 8, setRatio: 1.40, pointsRatio: 1.04 },
// //     { rank: 5, name: 'MORADABAD BULLS', total: 5, win: 2, loss: 3, points: 7, setRatio: 0.67, pointsRatio: 0.91 },
// //     { rank: 6, name: 'KASHI WARRIORS', total: 5, win: 2, loss: 3, points: 7, setRatio: 0.67, pointsRatio: 0.89 },
// //     { rank: 7, name: 'LUCKNOW TIGERS', total: 4, win: 2, loss: 2, points: 5, setRatio: 0.71, pointsRatio: 0.95 },
// //     { rank: 8, name: 'AYODHYA SUPER KINGS', total: 5, win: 1, loss: 4, points: 5, setRatio: 0.50, pointsRatio: 0.89 },
// //   ];  
  
  

//   const [teams, setTeams] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // Fetch leaderboard from backend
//   useEffect(() => {
//     const fetchLeaderboard = async () => {
//       try {
//         const response = await api.get('/getallLeaderboard');


//         console.log("Leaderboard fetched successfully:", response.data);
//         // Normalize & ensure missing values are zero
//         const normalizedTeams = response.data.map(team => ({
//           rank: team.rank || 0,
//           name: team.name || team.teamname || 'Unknown',
//           total: team.total || team.totalMatches || 0,
//           win: team.win || team.totalWins || 0,
//           loss: team.loss || team.totalLosses || 0,
//           points: team.points || 0,
//           setRatio: team.setRatio || 0,
//           pointsRatio: team.pointsRatio || 0,
//           allMatches: team.allMatches || [],
//           nextMatch: team.nextMatch || 'TBD'
//         }));

//         // Sort based on your rules: Wins → Points → Set Ratio → Points Ratio
//         const sortedTeams = [...normalizedTeams].sort((a, b) => {
//           if (b.win !== a.win) return b.win - a.win;
//           if (b.points !== a.points) return b.points - a.points;
//           if (b.setRatio !== a.setRatio) return b.setRatio - a.setRatio;
//           return b.pointsRatio - a.pointsRatio;
//         });

//         setTeams(sortedTeams);
//       } catch (err) {
//         console.error('Error fetching Points Table:', err);
//         setError('Failed to load Points Table');
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchLeaderboard();
//   }, []);

//   // Map last matches to W/L/T icons
//   const getFormIcons = (allMatches = []) => {
//     const lastMatches = allMatches.slice(-5).reverse();
//     if (lastMatches.length === 0) return Array(5).fill('T');
//     return lastMatches.map(match => match.result?.charAt(0) || 'T');
//   };

//   if (loading) {
//     return (
//       <div className="loading-container">
//         <p>Loading leaderboard...</p>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="error-container">
//         <p className="error-message">{error}</p>
//       </div>
//     );
//   }

//   return (
//     <div className="leaderboard-container">
//       <table className="leaderboard-table table-striped">
//         <thead>
//           <tr>
//             <th>Rank</th>
//             <th>Team</th>
//             <th>Matches</th>
//             <th>Wins</th>
//             <th>Losses</th>
//             <th>Points</th>
//             <th>Set Ratio</th>
//             <th>Points Ratio</th>
//             {/* <th>Form</th>
//             <th>Next Match</th> */}
//           </tr>
//         </thead>
//         <tbody>
//           {teams.map((team, index) => {
//             const formIcons = getFormIcons(team.allMatches);

//             return (
//               <tr key={index}>
//                 <td className="text-center">{index + 1}</td>
//                 <td className="text-left trhighlight">{team.name}</td>
//                 <td>{team.total}</td>
//                 <td>{team.win}</td>
//                 <td>{team.loss}</td>
//                 <td>{team.points}</td>
//                 <td>{parseFloat(team.setRatio).toFixed(2)}</td>
//                 <td>{parseFloat(team.pointsRatio).toFixed(2)}</td>
//                 {/* <td>
//                   <div className="form-icons">
//                     {formIcons.map((result, idx) => (
//                       <span
//                         key={idx}
//                         className={`form-icon trhighlight ${
//                           result === 'W' ? 'win' : result === 'L' ? 'loss' : ''
//                         }`}
//                       >
//                         {result}
//                       </span>
//                     ))}
//                   </div>
//                 </td>
//                 <td>{team.nextMatch}</td> */}
//               </tr>
//             );
//           })}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// export default LeaderboardTable;



import React from 'react';
import './LeaderboardTable.css';

const LeaderboardTable = () => {
  const teams = [
    { rank: 1, name: 'MUZAFFARNAGAR LIONS (Q)', total: 5, win: 4, loss: 1, points: 13, setRatio: 2.75, pointsRatio: 1.22 },
    { rank: 2, name: 'MATHURA YODHAS (Q)', total: 5, win: 4, loss: 1, points: 12, setRatio: 2.00, pointsRatio: 1.08 },
    { rank: 3, name: 'GORAKHPUR GIANTS (Q)', total: 5, win: 3, loss: 2, points: 12, setRatio: 2.00, pointsRatio: 1.07 },
    { rank: 4, name: 'NOIDA THUNDERS (Q)', total: 5, win: 2, loss: 3, points: 8, setRatio: 0.88, pointsRatio: 1.08 },
    { rank: 5, name: 'MORADABAD BULLS', total: 5, win: 2, loss: 3, points: 7, setRatio: 0.67, pointsRatio: 0.91 },
    { rank: 6, name: 'KASHI WARRIORS', total: 5, win: 2, loss: 3, points: 7, setRatio: 0.67, pointsRatio: 0.89 },
    { rank: 7, name: 'LUCKNOW TIGERS', total: 5, win: 2, loss: 3, points: 5, setRatio: 0.50, pointsRatio: 0.91 },
    { rank: 8, name: 'AYODHYA SUPER KINGS', total: 5, win: 1, loss: 4, points: 5, setRatio: 0.50, pointsRatio: 0.89 },
  ];
   
  
  


  return (
    <div className="leaderboard-container">
      <table className="leaderboard-table">
        <thead>
          <tr>
            <th>RANK</th>
            <th>TEAM NAME</th>
            <th>MATCHES</th>
            <th>WIN</th>
            <th>LOSS</th>
            <th>POINTS</th>
            <th>SET RATIO</th>
            <th>POINTS RATIO</th>
          </tr>
        </thead>
        <tbody>
          {teams.map((team) => (
            <tr key={team.rank}>
              <td>{team.rank}</td>
              <td className="team-name">{team.name}</td>
              <td>{team.total}</td>
              <td>{team.win}</td>
              <td>{team.loss}</td>
              <td>{team.points}</td>
              <td>{team.setRatio}</td>
              <td>{team.pointsRatio}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default LeaderboardTable;